module.exports = __webpack_public_path__ + "img/map-marker-alert-outline.3e659ba8.svg";